export const featuredPortfolio = [
  {
    id: 1,
    title: "Cryptocurrency Tracker App",
    img: "../../assets/images/bermix-studio-aX1hN4uNd-I-unsplash.jpg",
    URL: "https://stupefied-panini-5c9a39.netlify.app",
  },
  {
    id: 2,
    title: "Budget App",
    img: "../../assets/images/northfolk-Ok76F6yW2iA-unsplash.jpg",
    URL: "https://quirky-banach-d93d26.netlify.app",
  },
  {
    id: 3,
    title: "Food Order App",
    img: "../../assets/images/nienke-broeksema-_hiPJ6Z0vao-unsplash.jpg",
    URL: "https://brave-kilby-f39ec9.netlify.app",
  },
  {
    id: 4,
    title: "Travel Website",
    img: "../../assets/images/philipp-kammerer-6Mxb_mZ_Q8E-unsplash.jpg",
    URL: "https://dazzling-goodall-907d8e.netlify.app",
  },
  {
    id: 5,
    title: "Meetup Clone App",
    img: "../../assets/images/redd-PTRzqc_h1r4-unsplash.jpg",
    URL: "https://stupefied-mcnulty-789d5e.netlify.app",
  },
  {
    id: 6,
    title: "CRUD App",
    img: "../../assets/images/kimberly-farmer-lUaaKCUANVI-unsplash.jpg",
    URL: "https://61d7fbaf689023c8cd317fe3--admiring-minsky-fe676a.netlify.app/",
  },
];

export const webPortfolio = [
  {
    id: 7,
    title: "Portfolio Website",
    img: "../../assets/images/kimberly-farmer-lUaaKCUANVI-unsplash.jpg",
    URL: "https://sad-brattain-dea44e.netlify.app/",
  },
  {
    id: 8,
    title: "Travel Website",
    img: "../../assets/images/philipp-kammerer-6Mxb_mZ_Q8E-unsplash.jpg",
    URL: "https://dazzling-goodall-907d8e.netlify.app",
  },
];

export const mobilePortfolio = [
  {
    id: 9,
    title: "Ingredients List App",
    img: "../../assets/images/james-lee-Mfjq1hi-lVg-unsplash.jpg",
    URL: "https://priceless-thompson-00aa61.netlify.app",
  },
  {
    id: 10,
    title: "To Do List App",
    img: "../../assets/images/emma-matthews-digital-content-production-p6g6S_kXkFc-unsplash.jpg",
    URL: "https://practical-goldwasser-0d34b3.netlify.app",
  },
  {
    id: 11,
    title: "Budget App",
    img: "../../assets/images/northfolk-Ok76F6yW2iA-unsplash.jpg",
    URL: "https://quirky-banach-d93d26.netlify.app",
  },
  {
    id: 12,
    title: "Meetup Clone App",
    img: "../../assets/images/redd-PTRzqc_h1r4-unsplash.jpg",
    URL: "https://stupefied-mcnulty-789d5e.netlify.app",
  },
  {
    id: 13,
    title: "Menu App",
    img: "../../assets/images/nienke-broeksema-_hiPJ6Z0vao-unsplash.jpg",
    URL: "https://brave-kilby-f39ec9.netlify.app",
  },
  {
    id: 14,
    title: "Movie List API",
    img: "../../assets/images/sean-benesh-6Nbo9Pn0yJA-unsplash.jpg",
    URL: "https://60eac0fb35cf884c47fae4f8--eloquent-poitras-8bbaf7.netlify.app/",
  },
];

export const designPortfolio = [
  {
    id: 15,
    title: "Online Learning Website",
    img: "../../assets/images/windows-v94mlgvsza4-unsplash.jpg",
    URL: "https://zealous-northcutt-944b16.netlify.app/",
  },
  {
    id: 16,
    title: "Open Layers Map and Sidebar",
    img: "../../assets/images/cardmapr-nl-lMcHm_tzR3I-unsplash.jpg",
    URL: "https://blissful-saha-473084.netlify.app/",
  },
  {
    id: 17,
    title: "Old Portfolio",
    img: "../../assets/images/kimberly-farmer-lUaaKCUANVI-unsplash.jpg",
    URL: "https://sad-brattain-dea44e.netlify.app/",
  },
];

export const contentPortfolio = [
  {
    id: 18,
    title: "Validation Page",
    img: "../../assets/images/siriwan-arunsiriwattana-gs0coXLmjdI-unsplash.jpg",
    URL: "https://awesome-hypatia-462255.netlify.app",
  },
  {
    id: 19,
    title: "Users List",
    img: "../../assets/images/taras-shypka-iFSvn82XfGo-unsplash.jpg",
    URL: "https://zealous-goldberg-a40548.netlify.app/",
  },
  {
    id: 20,
    title: "React Authentication",
    img: "../../assets/images/markus-spiske-bMvuh0YQQ68-unsplash.jpg",
    URL: "https://heuristic-wilson-c148d9.netlify.app",
  },
  {
    id: 21,
    title: "Movie List: Star Wars API",
    img: "../../assets/images/daniel-cheung-B7N0IjiIJYo-unsplash.jpg",
    URL: "https://60eac15f6f32a8c8908c06a1--jolly-johnson-f7127d.netlify.app/",
  },
  {
    id: 22,
    title: "Carousel Component",
    img: "../../assets/images/kelly-sikkema--1_RZL8BGBM-unsplash.jpg",
    URL: "https://dazzling-ramanujan-f38337.netlify.app/",
  },
];
